import React from "react";
import { ScrollView, View } from "react-native";
import Empty from "./Empty";
import Loading from "./Loading";
import { RefreshControl } from "react-native-web-refresh-control";
import Errors from "./Errors";

function Content({
  refreshable = false,
  scrollEnabled = false,
  refreshing = false,
  onRefresh = () => {},
  children,
  loading = false,
  empty = null,
  style = {},
  error,
  onTryAgain,
}) {
  return (
    <>
      {!error ? (
        loading ? (
          <Loading />
        ) : (
          <ScrollView
            showsVerticalScrollIndicator={false}
            refreshControl={
              refreshable ? (
                <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
              ) : null
            }
            scrollEnabled={scrollEnabled}
            contentContainerStyle={empty ? { flex: 1 } : {}}
          >
            {!empty ? (
              <View
                style={[{ paddingHorizontal: 20, paddingVertical: 10 }, style]}
              >
                {children}
              </View>
            ) : (
              <Empty
                iconType={empty.iconType}
                iconName={empty.iconName}
                text={empty.text}
              />
            )}
          </ScrollView>
        )
      ) : (
        <Errors error={error} onPress={onTryAgain} />
      )}
    </>
  );
}

export default Content;
